// Editor för HeadingBlock — text, nivå (H1/H2/H3) och justering.

import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import { Box, MenuItem, Stack, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { HeadingBlock, HeadingLevel, TextAlign } from '../types';

type Props = {
  block: HeadingBlock;
  onChange: (patch: Partial<HeadingBlock>) => void;
};

export const HeadingBlockEditor = ({ block, onChange }: Props) => {
  const { t } = useTranslation('groupMessage');
  return (
    <Stack spacing={2}>
      <TextField
        label={t('builder.editors.text') as string}
        value={block.text}
        onChange={(e) => onChange({ text: e.target.value })}
        fullWidth
        size='small'
      />
      <TextField
        select
        label={t('builder.editors.level') as string}
        value={block.level}
        onChange={(e) => onChange({ level: Number(e.target.value) as HeadingLevel })}
        size='small'
      >
        <MenuItem value={1}>{t('builder.editors.levelH1')}</MenuItem>
        <MenuItem value={2}>{t('builder.editors.levelH2')}</MenuItem>
        <MenuItem value={3}>{t('builder.editors.levelH3')}</MenuItem>
      </TextField>
      <Box>
        <Typography variant='caption' color='text.secondary' sx={{ display: 'block', mb: 0.5 }}>
          {t('builder.editors.align')}
        </Typography>
        <ToggleButtonGroup
          value={block.align}
          exclusive
          size='small'
          onChange={(_, value: TextAlign | null) => {
            if (value) onChange({ align: value });
          }}
          fullWidth
        >
          <ToggleButton value='left' aria-label={t('builder.editors.alignLeft') as string}>
            <FormatAlignLeftIcon fontSize='small' />
          </ToggleButton>
          <ToggleButton value='center' aria-label={t('builder.editors.alignCenter') as string}>
            <FormatAlignCenterIcon fontSize='small' />
          </ToggleButton>
          <ToggleButton value='right' aria-label={t('builder.editors.alignRight') as string}>
            <FormatAlignRightIcon fontSize='small' />
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Stack>
  );
};

export default HeadingBlockEditor;
